import React, { useState, useEffect, useCallback } from "react";
import { Calendar as BigCalendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { ViewEventsByMonth } from "../../../services/EventsService";
import { useAxiosInstance } from "../../../services/Interceptor";
import "tailwindcss/tailwind.css";
import EventComponent from "./EventCalendar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleArrowLeft,
  faCircleArrowRight,
} from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { loadEventsAction } from "../../../store/slices/calendarSlice";

const localizer = momentLocalizer(moment);

export default function Calendar({ onSelectEvent }) {
  const [events, setEvents] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [currentDate, setCurrentDate] = useState(new Date());
  const apiInstance = useAxiosInstance();
  const r_calendar = useSelector((state) => state.calendar);
  const dispatch = useDispatch();
  const [height, setHeight] = React.useState(window.innerHeight);
  const adjustedHeight = height - 180;

  const fetchEvents = useCallback(async () => {
    const month = currentDate.getMonth() + 1;
    const year = currentDate.getFullYear();
    try {
      const listEvent = await ViewEventsByMonth(apiInstance, month, year);
      setEvents(
        listEvent.map((event) => ({
          ...event,
          start: moment(event.date).startOf("day").toDate(),
          end: moment(event.date).endOf("day").toDate(),
        })),
      );
      dispatch(loadEventsAction(true));
    } catch (err) {
      console.error("Error fetching events:", err);
    }
  }, [currentDate, apiInstance, dispatch]);

  useEffect(() => {
    if (!r_calendar.loadEvents || currentDate) {
      fetchEvents(currentDate);
      setSelectedEvent(null);
    }
  }, [currentDate, fetchEvents, r_calendar.loadEvents]);

  const handleSelectEvent = (event) => {
    setSelectedEvent(event);
    onSelectEvent(event);
  };

  const handleNavigate = (newDate) => {
    setCurrentDate(newDate);
    setSelectedEvent(null);
  };

  useEffect(() => {
    window.addEventListener("resize", updateHeight);
    return () => window.removeEventListener("resize", updateHeight);
  }, []);

  const updateHeight = () => {
    setHeight(window.innerHeight);
  };

  const handleDragStart = () => {};

  return (
    <div className="flex flex-col p-2 rounded-md shadow-lg bg-white overflow-hidden">
      <p className="uppercase text-xl mb-4">Calendar</p>
      <BigCalendar
        localizer={localizer}
        events={events}
        startAccessor="start"
        endAccessor="end"
        views={["month"]}
        defaultView="month"
        onNavigate={handleNavigate}
        style={{ height: `${adjustedHeight}px` }}
        components={{
          toolbar: (props) => <CustomToolbar {...props} />,
          event: (props) => (
            <EventComponent
              {...props}
              onClick={handleSelectEvent}
              isSelected={selectedEvent && selectedEvent.id === props.event.id}
            />
          ),
        }}
        onSelectEvent={handleSelectEvent}
        popup
        showMultiDayTimes
        handleDragStart={handleDragStart}
      />
    </div>
  );
}

function CustomToolbar(props) {
  const goToBack = () => {
    let mDate = props.date;
    let newDate = new Date(mDate.getFullYear(), mDate.getMonth() - 1, 1);
    props.onNavigate("prev", newDate);
  };

  const goToNext = () => {
    let mDate = props.date;
    let newDate = new Date(mDate.getFullYear(), mDate.getMonth() + 1);
    props.onNavigate("next", newDate);
  };

  return (
    <div className="flex justify-between p-2 border-b mb-4">
      <span className="text-lg font-bold">
        {moment(props.date).format("MMMM YYYY")}
      </span>
      <div className="buttons flex space-x-2">
        <FontAwesomeIcon
          icon={faCircleArrowLeft}
          size="lg"
          className="cursor-pointer"
          onClick={goToBack}
        />
        <FontAwesomeIcon
          icon={faCircleArrowRight}
          size="lg"
          className="cursor-pointer"
          onClick={goToNext}
        />
      </div>
    </div>
  );
}
